<!-- <template>
  <iframe
    :src="url"
    height="100%"
    width="100%"
    style="height: 100%; width: 100%"
  ></iframe>
</template>

<script>
// import { AMOS_URL } from '@/main';

export default {
  props: {
    url: {
      type: String,
      default: '/amos/',
    },
  },
}
</script> -->

<script setup>
import { AMOS_URL } from '@/main'
import { onMounted, ref } from 'vue'
import { addDash } from '@/utils/urlFormatters'
import store from '@/store'

store.commit('SET_VIEW_STRUCTURES', false)

const loading = ref(true)

const onLoad = () => {
  loading.value = false
}
</script>

<template>
  <div class="d-flex flex-column h-100 w-100">
    <v-progress-linear
      v-if="loading"
      indeterminate
    />
    <iframe
      :src="addDash(AMOS_URL)"
      title="AMOS"
      :data-embedded="true"
      @load="onLoad"
      class="d-flex flex-column h-100 w-100 border-0"
      loading="lazy"
    />
  </div>
</template>
